/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import FloatingInput from "../FloatingInput";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const DefaultForm = ({ components, setFormState, formState }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { handleDynamicRegex, isRegexValid } = useApp();

  const handleInputChange = (e, validationRegex, itemKey) => {
    const regex = new RegExp(validationRegex, "u");
    const { name, value } = e.target;
    const trimmedValue = value.trimStart();

    if (regex) {
      const a = isRegexValid.some((item) => {
        return item?.itemKey === itemKey;
      });
      if (!a && !regex.test(trimmedValue)) {
        handleDynamicRegex([
          ...isRegexValid,
          { itemKey: itemKey, isValid: regex.test(trimmedValue) },
        ]);
      } else if (regex.test(trimmedValue)) {
        const indexKey = isRegexValid.findIndex(
          (item) => item?.itemKey === itemKey
        );
        if (indexKey != -1) {
          isRegexValid.splice(indexKey, 1);
          handleDynamicRegex([...isRegexValid]);
        }
      }
    }

    setFormState((prevState) => ({
      ...prevState,
      [name]: trimmedValue,
    }));
  };

  useEffect(() => {
    const initialState = components.reduce((acc, field) => {
      acc[field?.attributes?.key] = "";
      return acc;
    }, {});
    setFormState(initialState);
  }, []);

  return (
    <div className="form-container">
      {components.map((element, index) => {
        return (
          <FloatingInput
            key={index}
            label={
              routeName
                ? t(`${routeName}.${element.attributes?.label}`)
                : t(`app.${element.attributes?.label}`)
            }
            id={element.attributes?.key}
            placeholder={element?.label}
            value={formState[element.attributes?.key] || ""}
            handleChange={(e) =>
              handleInputChange(
                e,
                element?.attributes?.regex,
                element.attributes?.key
              )
            }
            name={element.attributes?.key}
            type={element.type}
            isInvalid={isRegexValid.some(
              (item) => item?.itemKey === element.attributes?.key
            )}
            errorMsg={t(
              routeName
                ? `${routeName}.${element.attributes?.errorMsg}`
                : `app.${element.attributes?.errorMsg}`
            )}
            maxLength={element.attributes?.maxLength}
            options={element.attributes?.options}
            optionModalHeading={element.attributes?.optionModalHeading}
            isRequired={element.attributes?.isRequired}
            noteMsg={
              element.attributes?.noteMsg
                ? routeName
                  ? t(`${routeName}.${element.attributes?.noteMsg}`)
                  : t(`app.${element.attributes?.noteMsg}`)
                : null
            }
            isTranslated={element.attributes?.isTranslated}
          />
        );
      })}
    </div>
  );
};
export default DefaultForm;
